export default __webpack_public_path__ + "static/media/htich_view.6b518515.svg";